// extracted by mini-css-extract-plugin
export default {"main":"RussianGame_main__ThIdC"};